export default {
  type: 'menu',
  code: '15000000'
}
